import React, { Component } from "react";
import { urlMap } from "../../utils";

function getQueryParam(name) {
  return new URLSearchParams(window.location.search).get(name);
}

function isMobileBrowser() {
  return /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);
}

function openMobileApp(verified) {
  const appUrl = `storyclub://verified?verified=${verified}`;
  window.location.href = appUrl;

  // Give Android enough time to hand off to the installed app. Only fall back
  // when this page remains visible, which means the app was not opened.
  let handedOff = false;
  const markHandedOff = () => {
    handedOff = true;
  };
  window.addEventListener("pagehide", markHandedOff, { once: true });
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "hidden") markHandedOff();
  }, { once: true });

  window.setTimeout(() => {
    if (!handedOff && document.visibilityState === "visible") {
      window.location.replace(`/login?verified=${verified}`);
    }
  }, 2500);
}

class VerifyEmail extends Component {
  state = {
    status: "loading",
  };

  async componentDidMount() {
    const token = getQueryParam("token") || "";
    const email = getQueryParam("email") || "";

    if (!token || !email) {
      this.setState({ status: "invalid" });
      return;
    }

    try {
      const res = await fetch(urlMap.verify, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, email }),
      });

      const data = await res.json().catch(() => ({}));

      if (res.ok) {
        const v = data.status === "already-verified" ? "already" : "1";
        if (isMobileBrowser()) {
          openMobileApp(v);
        } else {
          window.location.replace(`/login?verified=${v}`);
        }
      } else if (data.status === "expired") {
        window.location.replace(
          `/login?expired=1&email=${encodeURIComponent(email)}`
        );
      } else {
        this.setState({ status: "invalid" });
      }
    } catch {
      this.setState({ status: "error" });
    }
  }

  render() {
    const { status } = this.state;

    return (
      <div className="mx-auto max-w-md p-6 text-center">
        {status === "loading" && <p>Verifying your link…</p>}
        {status === "invalid" && <p>Invalid verification link.</p>}
        {status === "error" && <p>Something went wrong. Try again later.</p>}
      </div>
    );
  }
}

export default VerifyEmail;
